/* PR · Serienwelt (Runde 2): Filter, Sortierung, Rasteransicht, Set-Finder, Bild-Unterbrecher an fester Position,
   Ersparnis in Euro und Chip nach einem Pack-Wechsel. Ohne JS bleibt alles sichtbar und verlinkt. */
/* Runde 6 (Owner 07.10., Punkte 5 und 6; Leitstand-Entscheidung „Mehrteiler vs. Einzelteile“): Angebot an der Karte nach einem Pack-Wechsel.
   Mehrteiler (4er, 6er, n Teile): Ersparnis in Euro, Streichpreis mit Sternchen (Summe der Einzelpreise, Fußnote je Seite).
   Echte Einzelteile („Einzeln“) mit compare_at > Preis: Rabatt in Prozent, abgerundet, ohne Sternchen. Gilt auf allen Karten inkl. Last Pieces.
   Chips aus pr-bildtypo (.pr-chip, .pr-chip--neon). */
window.prCardOffer = window.prCardOffer || ((card) => {
  if (!card) return;
  const money = (cents) => `${(cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/,00$/, '')} €`;
  const options = [...card.querySelectorAll('[data-pack-link]')];
  const option = options.find(o => o.getAttribute('aria-current') === 'true');
  if (!option) return;
  const label = option.textContent.trim();
  const packed = /^\d+er$/.test(label) || /Teile|Set/.test(label);
  const price = Number(option.dataset.price), compare = Number(option.dataset.comparePrice || 0);
  const diff = compare > price ? compare - price : 0;
  const pct = diff > 0 ? Math.floor(diff * 100 / compare) : 0;
  const chip = card.querySelector('[data-pack-chip]');
  if (chip) chip.textContent = /^\d+er$/.test(label) ? `${label}-Set` : label;
  const sale = card.querySelector('[data-sale-badge]');
  if (sale) {
    const show = packed ? diff > 0 : pct >= 1;
    sale.hidden = !show;
    delete sale.dataset.deepSale;
    if (show) sale.textContent = packed ? `−${money(diff)}` : `−${pct} %`;
  }
  card.dataset.discount = String(pct);
  card.querySelectorAll('[data-stern]').forEach(s => s.remove());
  const strike = card.querySelector('.prw-card__price s');
  if (strike) {
    strike.className = 'pr-streich'; strike.removeAttribute('title');
    if (packed && diff > 0) { const star = document.createElement('span'); star.className = 'r2-stern'; star.dataset.stern = ''; star.setAttribute('aria-hidden', 'true'); star.textContent = '*'; strike.after(star); }
  }
});
/* Runde 7 (K5): Füllkachel gegen Waisen in der letzten Rasterreihe. Zählt die sichtbaren Karten nach dem letzten
   ganzzeiligen Element (Bild-Unterbrecher, Set-Finder), füllt die Lücke der letzten Reihe mit einer Kachel, die die
   restlichen Spalten überspannt. Nur, wenn alle Karten gezeigt sind (kein „Mehr anzeigen“). Ohne JS bleibt sie versteckt. */
window.prRasterFill = window.prRasterFill || ((grid, fill, more) => {
  if (!grid || !fill) return;
  fill.hidden = true; fill.style.removeProperty('grid-column');
  if (more) return;
  const cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length;
  const items = [...grid.children].filter(el => el !== fill && !el.hidden && getComputedStyle(el).display !== 'none');
  if (cols < 2 || !items.length) return;
  // Dichtes Packen (grid-auto-flow: dense, Serienwelt) füllt Lücken vor ganzzeiligen Elementen mit späteren Karten auf;
  // dann bestimmt die Gesamtzahl der Karten die letzte Reihe, sonst die Karten nach dem letzten ganzzeiligen Element.
  const dense = getComputedStyle(grid).gridAutoFlow.includes('dense');
  let run = 0;
  items.forEach(el => { if (el.matches('[data-breaker], [data-finder], .r2-break, .r2-finder') || getComputedStyle(el).gridColumnEnd === '-1') { if (!dense) run = 0; } else run++; });
  const rest = run % cols;
  if (!rest) return;
  items[items.length - 1].after(fill);
  fill.style.gridColumn = `span ${cols - rest}`;
  // Höhe wie das Kartenbild der letzten Karte: die Kachel liest sich als Bild in der Reihe, nicht als leerer Block.
  const media = items[items.length - 1].querySelector('.r2-card__media, .prw-card__media');
  fill.style.height = media ? `${Math.round(media.getBoundingClientRect().height)}px` : '';
  fill.hidden = false;
});
/* Runde 6: eine Fußnote je Seite, sichtbar, solange ein Streichpreis mit Sternchen zu sehen ist (auch in der Heldenkarte). */
window.prFussnote = window.prFussnote || ((root) => {
  const note = root?.querySelector('[data-fussnote]'); if (!note) return;
  note.hidden = !root.querySelector('[data-stern]');
});

(() => {
  if (customElements.get('pr-collection-world')) return;
  class CollectionWorld extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const grid = this.querySelector('[data-catalog-grid]');
      if (!grid) return;
      const cards = [...grid.querySelectorAll('[data-world-card]')];
      cards.forEach((card, index) => { card.dataset.order = index; });
      const breakers = [...grid.querySelectorAll('[data-breaker]')].map(el => ({ el, after: Number(el.dataset.after) || 0 }));
      const finder = grid.querySelector('[data-finder]');
      const filters = [...this.querySelectorAll('[data-filter]')];
      const sort = this.querySelector('[data-sort]');
      const views = [...this.querySelectorAll('[data-view]')];
      const more = this.querySelector('[data-more]');
      const results = this.querySelector('[data-results]');
      const empty = this.querySelector('[data-empty]');
      const fill = this.querySelector('[data-raster-fill]');
      const pageSize = Math.max(4, Number(grid.dataset.pageSize) || 24);
      let category = 'all';
      let limit = pageSize;
      const byOrder = (a, b) => Number(a.dataset.order) - Number(b.dataset.order);
      const byPrice = (dir) => (a, b) => (Number(a.dataset.price) - Number(b.dataset.price)) * dir;
      const sorter = () => sort && sort.value === 'price-up' ? byPrice(1) : sort && sort.value === 'price-down' ? byPrice(-1) : byOrder;
      const matches = (card) => category === 'all' || card.dataset.category === category;
      const update = () => {
        const sets = cards.filter(c => c.dataset.category === 'sets' && matches(c)).sort(sorter());
        const singles = cards.filter(c => c.dataset.category !== 'sets' && matches(c)).sort(sorter());
        const selected = [...sets, ...singles];
        const visible = selected.slice(0, limit);
        const hidden = cards.filter(c => !visible.includes(c));
        // Reihenfolge aufbauen: Karten, nach den Sets die Finder-Leiste, Unterbrecher nach n sichtbaren Karten.
        const sequence = [];
        let shown = 0;
        const placeBreakers = () => breakers.forEach(b => { if (b.after === shown && !sequence.includes(b.el)) sequence.push(b.el); });
        visible.forEach((card, i) => {
          sequence.push(card); shown++;
          placeBreakers();
          if (finder && sets.length > 1 && sets.includes(card) && i === Math.min(2, sets.length, visible.length) - 1) sequence.push(finder);
        });
        breakers.forEach(b => { b.el.hidden = !sequence.includes(b.el); if (b.el.hidden) sequence.push(b.el); });
        if (finder) { finder.hidden = !sequence.includes(finder); if (finder.hidden) sequence.push(finder); }
        hidden.forEach(c => { c.hidden = true; sequence.push(c); });
        visible.forEach(c => { c.hidden = false; });
        if ([...grid.children].filter(el => el !== fill).some((el, i) => el !== sequence[i])) grid.replaceChildren(...sequence);
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === category)));
        if (results) results.textContent = visible.length < selected.length ? `${visible.length} von ${selected.length} Produkten` : `${selected.length} ${selected.length === 1 ? 'Produkt' : 'Produkte'}`;
        if (empty) empty.hidden = selected.length > 0;
        if (more) { more.hidden = limit >= selected.length; more.textContent = `Mehr anzeigen (noch ${Math.max(0, selected.length - visible.length)})`; }
        placeFill();
      };
      // Runde 7 (K5): Füllkachel in der letzten Reihe; in „Alle“ führt sie zu allen Geschirrsets, in einem Filter zurück zu „Alle“.
      const placeFill = () => {
        if (!fill) return;
        fill.querySelector('[data-fill-alle]')?.toggleAttribute('hidden', category === 'all');
        fill.querySelector('[data-fill-sets]')?.toggleAttribute('hidden', category !== 'all');
        window.prRasterFill?.(grid, fill, !!(more && !more.hidden));
      };
      fill?.querySelector('[data-fill-alle]')?.addEventListener('click', () => { category = 'all'; limit = pageSize; update(); }, options);
      if (fill && 'ResizeObserver' in window) { let w = 0; this.resizer = new ResizeObserver(entries => { const nw = Math.round(entries[0].contentRect.width); if (nw !== w) { w = nw; placeFill(); } }); this.resizer.observe(grid); }
      filters.forEach(button => {
        const key = button.dataset.filter;
        if (key !== 'all' && !cards.some(card => card.dataset.category === key)) button.hidden = true;
        button.addEventListener('click', () => { category = key; limit = pageSize; update(); }, options);
      });
      sort?.addEventListener('change', () => { limit = pageSize; update(); }, options);
      more?.addEventListener('click', () => {
        const before = cards.filter(c => !c.hidden).length;
        limit += pageSize; update();
        const first = cards.filter(c => !c.hidden)[before];
        first?.querySelector('a')?.focus({ preventScroll: true });
      }, options);
      // Rasteransicht mobil: zwei Spalten oder eine Spalte (Merker nur in dieser Sitzung).
      const setView = (v, remember) => {
        grid.classList.toggle('r2-grid--one', v === '1');
        views.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.view === v)));
        if (remember) { try { sessionStorage.setItem('pr-r2-view', v); } catch {} }
      };
      views.forEach(b => b.addEventListener('click', () => setView(b.dataset.view, true), options));
      try { const saved = sessionStorage.getItem('pr-r2-view'); if (saved) setView(saved, false); } catch {}
      // Set-Finder: springt zur passenden Set-Karte.
      finder?.querySelectorAll('[data-finder-persons]').forEach(button => button.addEventListener('click', () => {
        const target = cards.find(c => c.dataset.category === 'sets' && c.dataset.persons === button.dataset.finderPersons && !c.hidden);
        if (!target) return;
        finder.querySelectorAll('[data-finder-persons]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        target.scrollIntoView({ block: 'center', behavior: reduced() ? 'instant' : 'smooth' });
        cards.forEach(c => c.classList.remove('is-target'));
        target.classList.add('is-target');
        target.querySelector('a')?.focus({ preventScroll: true });
        setTimeout(() => target.classList.remove('is-target'), 2200);
      }, options));
      // Nach einem Pack-Wechsel: Chip, Angebots-Chip, Streichpreis mit oder ohne Sternchen (window.prCardOffer), Titel ohne Pack-Klammer.
      this.addEventListener('pr:pack-change', event => queueMicrotask(() => {
        // Runde 4: erst nach dem Umsetzen von aria-current lesen (pr-pack-selector.js meldet vorher).
        const card = event.target.closest('[data-world-card]');
        if (!card) return;
        window.prCardOffer?.(card);
        window.prCardTitle?.(card);
        window.prFussnote?.(this);
      }), options);
      window.prFussnote?.(this);
      const tools = this.querySelector('[data-catalog-tools]'); if (tools) tools.hidden = false;
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.resizer?.disconnect(); this.resizer = null; }
  }
  customElements.define('pr-collection-world', CollectionWorld);
})();

/* PR · Kartenstreifen (Runde 4, Owner-Punkt 7): Kartenbild quer wischen wechselt Bild und aktiven Punkt.
   Bei Pack-Punkten wird nach dem Einrasten die passende Pack-Option geklickt; pr-pack-selector.js zieht dann
   Preis, Titel, Chip und Ersparnis nach (pr:pack-change). Punkt-Klick oder Hover (Maus) scrollt den Streifen.
   Natives Scroll-Snap, kein Seiten-Scroll-Listener; Bilder bleiben lazy, das jeweils nächste wird vorgeladen. */
(() => {
  if (customElements.get('pr-card-strip')) return;
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hoverable = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  class CardStrip extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.hoverController) return;
      this.slides = [...this.querySelectorAll('[data-strip-slide]')];
      this.card = this.closest('[data-world-card]') || this.parentElement;
      this.index = Math.min(Math.max(0, this.slides.length - 1), Math.max(0, Number(this.dataset.start) || 0));
      // Runde 6 (Owner-Punkt 6): Zeigegerät über der Karte blendet weich auf das zweite Bild des sichtbaren Bilds bzw. Packs über.
      // Das Zweitbild wird erst beim Zeigen geladen und erst nach dem Dekodieren eingeblendet (kein Layout-Sprung, Bild liegt absolut im Slide).
      if (this.querySelector('[data-hover-src]')) {
        this.hoverController = new AbortController();
        this.card.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse' && hoverable()) this.loadHover(this.index); }, { signal: this.hoverController.signal });
      }
      if (this.slides.length < 2) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.classList.add('is-ready');
      this.jump(this.index);
      this.mark(this.index);
      let timer = 0;
      // Nur Scrollen durch die Person (Wischen, Trackpad, Tastatur) schaltet das Pack um; Layout-Sprünge nicht.
      const byUser = () => { this.userScroll = true; };
      ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(type => this.addEventListener(type, byUser, { passive: true, signal }));
      this.addEventListener('scroll', () => {
        // Versteckte Karten (Filter, „Mehr anzeigen“) verlieren ihre Scroll-Position: dann nichts umschalten.
        if (!this.clientWidth) return;
        const live = this.current();
        if (live !== this.shown) this.mark(live, true);
        clearTimeout(timer);
        timer = setTimeout(() => this.settle(), 140);
      }, { passive: true, signal });
      if ('onscrollend' in window) this.addEventListener('scrollend', () => { clearTimeout(timer); this.settle(); }, { signal });
      // Breite ändert sich (Rasterumschalter, Filter, Drehen): Position halten.
      if ('ResizeObserver' in window) { this.resizer = new ResizeObserver(() => { if (this.clientWidth) { this.jump(this.index); this.mark(this.index); } }); this.resizer.observe(this); }
      // Nächstes Bild vorladen, sobald die Karte in die Nähe kommt.
      if ('IntersectionObserver' in window) {
        this.watcher = new IntersectionObserver(entries => { if (entries.some(e => e.isIntersecting)) { this.preload(this.index); this.watcher.disconnect(); } }, { rootMargin: '300px 0px' });
        this.watcher.observe(this);
      }
      // Punkte: Pack-Optionen (pr-pack-selector) oder eigene Bild-Punkte.
      this.options = () => [...(this.card?.querySelectorAll('[data-pack-link]') || [])];
      const dots = [...(this.card?.querySelectorAll('[data-strip-dot]') || [])];
      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.go(i), { signal });
        dot.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse' && hoverable()) this.go(i); }, { signal });
      });
      this.options().forEach(option => option.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse' || !hoverable() || option.getAttribute('aria-current') === 'true') return;
        option.click();
      }, { signal }));
      // Pack gewechselt (Punkt-Klick, Hover oder Wischen): Streifen auf das Pack stellen.
      // pr-pack-selector.js meldet pr:pack-change, bevor es aria-current umsetzt; deshalb erst danach lesen.
      this.card?.addEventListener('pr:pack-change', () => queueMicrotask(() => {
        const i = this.options().findIndex(o => o.getAttribute('aria-current') === 'true');
        if (i >= 0 && i < this.slides.length && i !== this.index) this.go(i);
      }), { signal });
    }
    current() { const w = this.clientWidth || 1; return Math.max(0, Math.min(this.slides.length - 1, Math.round(this.scrollLeft / w))); }
    jump(i) { const w = this.clientWidth; if (!w) return; const prior = this.style.scrollSnapType; this.style.scrollSnapType = 'none'; this.scrollLeft = i * w; this.style.scrollSnapType = prior; }
    go(i) {
      if (i < 0 || i >= this.slides.length) return;
      this.index = i; this.preload(i); this.mark(i);
      this.scrollTo({ left: i * this.clientWidth, behavior: reduced() ? 'instant' : 'smooth' });
      this.commit(i);
      if (this.hoverController && hoverable() && this.card?.matches(':hover')) this.loadHover(i);
    }
    loadHover(i) {
      const slide = this.slides[i];
      const src = slide?.dataset.hoverSrc;
      if (!src || slide.querySelector('.r2-strip__hover')) return;
      const base = slide.querySelector('.r2-strip__img');
      const img = new Image();
      img.className = 'r2-strip__hover'; img.alt = ''; img.decoding = 'async'; img.setAttribute('aria-hidden', 'true');
      img.sizes = base?.getAttribute('sizes') || '25vw';
      img.srcset = [360, 480, 720, 1000].map(w => `${src.replace(/width=\d+/, `width=${w}`)} ${w}w`).join(', ');
      img.src = src.replace(/width=\d+/, 'width=720');
      slide.append(img);
      const ready = () => img.classList.add('is-loaded');
      if (img.decode) img.decode().then(ready, () => { if (img.complete && img.naturalWidth) ready(); else img.remove(); });
      else img.addEventListener('load', ready, { once: true });
    }
    settle() {
      if (!this.clientWidth) return;
      const i = this.current();
      if (!this.userScroll) { if (i !== this.index) this.jump(this.index); this.mark(this.index); return; }
      this.userScroll = false;
      this.mark(i);
      if (i === this.index) return;
      this.index = i; this.preload(i); this.commit(i);
      if (this.hoverController && hoverable() && this.card?.matches(':hover')) this.loadHover(i);
    }
    commit(i) {
      const options = this.options();
      if (options.length >= this.slides.length && options[i] && options[i].getAttribute('aria-current') !== 'true') options[i].click();
    }
    mark(i, live) {
      this.shown = i;
      this.slides.forEach((slide, k) => { const on = k === i; slide.toggleAttribute('aria-hidden', !on); if (on) slide.removeAttribute('tabindex'); else slide.setAttribute('tabindex', '-1'); });
      this.card?.querySelectorAll('[data-strip-dot]').forEach((dot, k) => { if (k === i) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      if (live) this.card?.querySelectorAll('[data-pack-link]').forEach((o, k) => o.classList.toggle('is-live', k === i));
      else this.card?.querySelectorAll('[data-pack-link].is-live').forEach(o => o.classList.remove('is-live'));
    }
    preload(i) { [i - 1, i, i + 1].forEach(k => { const img = this.slides[k]?.querySelector('img'); if (img && img.loading === 'lazy') img.loading = 'eager'; }); }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.hoverController?.abort(); this.hoverController = null; this.resizer?.disconnect(); this.watcher?.disconnect(); }
  }
  customElements.define('pr-card-strip', CardStrip);
})();

/* Runde 4 (Owner-Punkt 8): Nach einem Pack-Wechsel Serie und Titel wieder in eine Zeile setzen („Vela Luna · Speiseteller“). */
window.prCardTitle = window.prCardTitle || ((card) => {
  const h3 = card?.querySelector('.prw-card__info h3'); if (!h3) return;
  const title = h3.textContent.replace(/^.*?\s·\s/, h3.dataset.series ? '' : '$&').replace(/\s*\(\d+er[ -]?Set\s*\)\s*/gi, '').replace(/\s*\(\d+[ -]?teilig\)\s*/gi, '').trim();
  if (!h3.dataset.series) { h3.textContent = title; return; }
  const series = document.createElement('span'); series.className = 'r2-card__series'; series.textContent = h3.dataset.series;
  const clean = title.startsWith(h3.dataset.series) ? title.slice(h3.dataset.series.length).replace(/^\s*[·-]?\s*/, '') : title;
  h3.replaceChildren(series, ` · ${clean}`);
});
